import React from 'react';
import PropTypes from 'prop-types';

import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import RsTableToolbarButton from '@Pages/RetroSynthesis/components/RsTableToolbarButton';
import RsRoutesSelectionBar from '@Pages/RetroSynthesis/components/RsRoutesSelectionBar/RsRoutesSelectionBar';
import { useHistory } from 'react-router-dom';
import HeaderInfoTooltip from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoTooltip';
import LegendTooltipContent from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteToolbar/components/LegendTooltipContent';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import ConditionsButton from './components/ConditionsButton';

import './ProjectRouteToolbar.scss';

function ProjectRouteToolbar({ projectId, routeId, conditionsIsShown, setConditionsIsShown, onExport, routeType }) {
  const history = useHistory();
  const routeClickHandler = (route) => {
    history.push(RsRoute.getProjectRouteTreeViewLink(projectId, route.id));
  };

  return (
    <RsTableToolbar className="rs-table-toolbar--white rs-route-toolbar">
      <div className="rs-table-toolbar__left-controls">
        <RsTableToolbarButton icon="upload" label="Export" onClick={onExport} />
        <RsTableToolbarButton icon="information" label="Legend" data-for="project-route-toolbar-legend" data-event="click" data-tip />
        <HeaderInfoTooltip id="project-route-toolbar-legend" rightAlign>
          <LegendTooltipContent />
        </HeaderInfoTooltip>
      </div>
      <div className="rs-table-toolbar__center-controls">
        <RsRoutesSelectionBar activeRoute={routeId} setActiveRoute={routeClickHandler} projectId={projectId} />
      </div>
      <div className="rs-table-toolbar__right-controls rs-route-toolbar__right-controls">
        <ConditionsButton conditionsIsShown={conditionsIsShown} setConditionsIsShown={setConditionsIsShown} routeType={routeType} />
      </div>
    </RsTableToolbar>
  );
}

ProjectRouteToolbar.defaultProps = {
  onExport: () => null,
};

ProjectRouteToolbar.propTypes = {
  onExport: PropTypes.func,
  setConditionsIsShown: PropTypes.func,
  routeType: PropTypes.string,
  projectId: PropTypes.string,
  routeId: PropTypes.string,
  conditionsIsShown: PropTypes.bool,
};

export default ProjectRouteToolbar;
